import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import { ReactComponent as LinkedInIcon } from './componenten/linkedin.svg';

function Footer() {
  return (
    <footer className="footer">
        <div className="footer-columns">

            <div className="footer-column">
                <h1>Contact & Socials</h1>
                <p><a href="mailto:info@mindis.nl">info@mindis.nl</a></p>
                <p><a href="tel:+31650641361">06 506 41 361</a></p>
                <a
                    href="https://www.linkedin.com/company/mindis25/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="LinkedInLink"
                >
                    <LinkedInIcon className="LinkedInSVG" />
                </a>
            </div>

            <div className="footer-column">
                <h1>Adres gegevens</h1>
                <p>Mindis V.O.F.</p>
                <p>Zonnelaan 62</p>
                <p>9742BN, Groningen (NL)</p>
            </div>

            <div className="footer-column">
                <h1>Zakelijke gegevens</h1>
                <p>KvK: 96700297</p>
                <p>BTW: NL867722101B01</p>
                <Link to="/algemene-voorwaarden">Algemene Voorwaarden (NL)</Link>
            </div>

        </div>
    </footer>
  );
}

export default Footer;
